import React from 'react';
import './tab-switch.scss';

export interface TabSwitchTab {
  id: string;
  label: string;
  count?: number;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
}

export interface TabSwitchProps {
  tabs: TabSwitchTab[];
  activeTabId: string;
  onTabChange: (id: string) => void;
}

const TabSwitch = ({ tabs, activeTabId, onTabChange }: TabSwitchProps) => {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className="tab-switch" role="tablist">
      {tabs.map((tab: TabSwitchTab) => {
        const isActive: boolean = tab.id === activeTabId;
        const buttonClassName: string = isActive
          ? 'tab-switch-button tab-switch-button-active'
          : 'tab-switch-button';

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={buttonClassName}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon && <span className="tab-switch-icon">{tab.icon}</span>}
            <span className="tab-switch-label">{tab.label}</span>
            {tab.badge && <span className="tab-switch-badge">{tab.badge}</span>}
            {typeof tab.count === 'number' && (
              <span className="tab-switch-count">{tab.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TabSwitch;
